<template>
  <div class="content-body">
    <div class="d-flex justify-content-between align-items-center w-100 mb-2">
      <h2 class="content-header-title" style="border-right: none;">Журнал ДСП документов ⇝ Аттестации</h2>
      <div>
        <button class="compose btn btn-success" @click="filterExport()">Выгрузить</button>
        <button class="compose btn btn-primary" @click="newRecord()">Добавить</button>
      </div>
    </div>

    <div class="card">
      <div class="card-header p-0">
        <div class="d-flex justify-content-between w-100">
          <div class="input-group input-group-merge shadow-none m-0 flex-grow-1">
            <div class="input-group-prepend">
              <span class="input-group-text border-0">
                <font-awesome-icon icon="fas fa-search" />
              </span>
            </div>
            <input type="text" @input="search()" v-model="searchQuery" class="form-control files-filter border-0 bg-transparent" placeholder="Поиск" />
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body h-100" style="padding: 0;">
        <div class="table-striped table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>Уч. №</th>
                <th>Дата документа</th>
                <th>Вид и заголовок документа</th>
                <th>Фамилия исполнителя</th>
                <th>Количество экземпляров документа</th>
                <th>Количество листов в экземпляре</th>
                <th>Куда отправлен документ</th>
                <th>Номера экземпляров</th>
                <th>Номер и дата сопроводительного документа или расписка в получении</th>
                <th>Отметка о возврате</th>
                <th>Примечание</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
            <template v-for="record in records">
              <tr v-for="entry in record.journal_entries" :style="{backgroundColor: randomColor(record.id)}">
                <td>{{entry.doc_number}}</td>
                <td>{{entry.doc_date}}</td>
                <td>{{entry.doc_type}}</td>
                <td>{{entry.doc_surname}}</td>
                <td>{{entry.doc_count}}</td>
                <td>{{entry.doc_count_2}}</td>
                <td>{{record.organization ? record.organization.name : ''}}</td>
                <td>{{entry.doc_number_2}}</td>
                <td>{{entry.doc_number_and_date}}</td>
                <td>{{entry.doc_callback}}</td>
                <td>{{entry.doc_comment}}</td>
                <td>
                  <div class="btn-group">
                    <a class="btn btn-sm btn-primary" @click.prevent="editRecord(entry, record.organization, record.journal_entries.length)" href="#"><font-awesome-icon icon="fas fa-edit" /></a>
                    <a class="btn btn-sm btn-danger" @click.prevent="deleteRecord(entry.id)" href="#"><font-awesome-icon icon="fas fa-trash" /></a>
                  </div>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>

        <nav class="justify-content-between d-flex mt-2 align-items-center">
          <div class="p-2">
            <label for="inputState" class="form-label mb-0">На странице: </label>
            <select class="form-select" v-model="perPage" @change="changePerPage()">
              <option :value="value" v-for="value in perPageList">{{value}}</option>
            </select>
          </div>
          <ul class="pagination mb-0">
            <li class="page-item">
              <a class="page-link" @click.prevent="selectPage(firstPage)" href="#">
                <font-awesome-icon class="mr-1" icon="fas fa-fast-backward" /> Первая
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="prevPage()" href="#">
                <font-awesome-icon class="mr-1" icon="fas fa-step-backward" /> Предыдущая
              </a>
            </li>
            <li class="page-item" :class="{ 'active': page.active }" v-for="page in visiblePages">
              <a class="page-link" @click.prevent="selectPage(page.name)" href="#">{{page.name}}</a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="nextPage()" href="#">
                Следующая <font-awesome-icon class="ml-1" icon="fas fa-step-forward" />
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="selectPage(lastPage)" href="#">
                Последняя <font-awesome-icon class="ml-1" icon="fas fa-fast-forward" />
              </a>
            </li>
          </ul>
          <div class="p-2">
            <p class="mb-0">(Всего страниц: {{lastPage}})</p>
          </div>
        </nav>

      </div>
    </div>

    <!-- Field Add/Edit Modal -->
    <div class="modal fade" id="addNewRecord" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-lg">
        <div class="modal-content pt-0">
        <div class="modal-header mb-1">
          <h5 class="modal-title" v-show="!editmode">Добавить</h5>
          <h5 class="modal-title" v-show="editmode">Редактировать</h5>

          <button type="button" class="close" @click="closeModal()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit.prevent="editmode ? updateRecord() : createRecord()">
            <div class="modal-body">
              <div class="form-group">
                <label class="form-label">Куда отправлен документ</label>
                <v-select
                  v-model="recordform.organization_id"
                  label="name"
                  :reduce="organization => organization.id"
                  :options="organizations"
                  :disabled="editmode"
                />
              </div>
              <div class="form-group">
                <label>Уч. №</label>
                <input v-model="recordform.doc_number" type="text" placeholder="Уч. №" class="form-control">
              </div>
              <div class="form-group">
                <label>Дата документа</label>
                <input v-model="recordform.doc_date" type="text" placeholder="Дата документа" class="form-control" :disabled="recordform.date_disable">
                <p v-show="recordform.date_disable" class="small">Изменение даты у записей созданных автоматически производится через изменение поля "Дата всех документов" в записи проекта</p>
              </div>
              <div class="form-group">
                <label>Вид и заголовок документа</label>
                <input v-model="recordform.doc_type" type="text" placeholder="Вид и заголовок документа" class="form-control">
              </div>
              <div class="form-group">
                <label>Фамилия исполнителя</label>
                <input v-model="recordform.doc_surname" type="text" placeholder="Фамилия исполнителя" class="form-control">
              </div>
              <div class="form-group">
                <label>Количество экземпляров документа</label>
                <input v-model="recordform.doc_count" type="text" placeholder="Количество экземпляров документа" class="form-control">
              </div>
              <div class="form-group">
                <label>Количество листов в экземпляре</label>
                <input v-model="recordform.doc_count_2" type="text" placeholder="Количество листов в экземпляре" class="form-control">
              </div>
              <div class="form-group">
                <label>Номера экземпляров</label>
                <input v-model="recordform.doc_number_2" type="text" placeholder="Номера экземпляров" class="form-control">
              </div>
              <div class="form-group">
                <label>Номер и дата сопроводительного документа или расписка в получении</label>
                <input v-model="recordform.doc_number_and_date" type="text" placeholder="Номер и дата сопроводительного документа или расписка в получении" class="form-control">
              </div>
              <div class="form-group">
                <label>Отметка о возврате</label>
                <input v-model="recordform.doc_callback" type="text" placeholder="Отметка о возврате" class="form-control">
              </div>
              <div class="form-group">
                <label>Примечание</label>
                <vue-editor v-model="recordform.doc_comment" rows="3" placeholder="Примечание"></vue-editor>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeModal()">Закрыть</button>
              <button v-show="editmode" type="submit" class="btn btn-success">Обновить</button>
              <button v-show="!editmode" type="submit" class="btn btn-primary">Создать</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- !Field Add/Edit Modal -->

    <div class="modal fade" id="filterExport" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-lg">
        <div class="modal-content pt-0">
          <div class="modal-header mb-1">
            <h5 class="modal-title">Выберите период выгрузки</h5>

            <button type="button" class="close" @click="closeModal()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit.prevent="editmode ? updateRecord() : createRecord()">
            <div class="modal-body">
              <div class="form-group">
                <label>От:</label>
                <input v-model="filter.dateStart" type="date" placeholder="От" class="form-control">
              </div>
              <div class="form-group">
                <label>По:</label>
                <input v-model="filter.dateEnd" type="date" placeholder="По" class="form-control">
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeModal()">Закрыть</button>
              <a class="compose btn btn-success" :href="'/api/journals/export/' + type + '?dateStart=' + filter.dateStart + '&dateEnd=' + filter.dateEnd">Выгрузить</a>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

  export default {
    components: {
      VueEditor
    },
    computed: {
      startPage() {
        if (this.currentPage < 4) {
          return 1;
        }
        if (this.currentPage == this.lastPage) {
          return this.startPage2;
        }

        if ((this.currentPage + 1) == this.lastPage) {
          return this.startPage2;
        }

        if ((this.currentPage + 2) == this.lastPage) {
          return this.startPage2;
        }
        return this.currentPage - 3;
      },
      startPage2(){
        if(this.lastPage > 6){
          return this.lastPage - 6;
        }
        if(this.lastPage > 5){
          return this.lastPage - 5;
        }
        if(this.lastPage > 4){
          return this.lastPage - 4;
        }
        if(this.lastPage > 3){
          return this.lastPage - 3;
        }
        if(this.lastPage > 2){
          return this.lastPage - 2;
        }
      },
      visiblePages() {
        let pages = [];
        let start = this.startPage;
        let end = Math.min(this.startPage + 6, this.lastPage);
        for (let i = start; i <= end; i++) {
          pages.push({
            name: i,
            active: i == this.currentPage
          });
        }
        return pages;
      }
    },
    data () {
      return {
        searchQuery: '',
        currentPage: 1,
        lastPage: 1,
        firstPage: 1,
        timeout: null,
        perPage: 10,
        perPageList: [10, 25, 50, 100],
        records: [],
        organizations: [],
        type: 77,
        recordform: new Form({
          id: null,
          type: 77,
          organization_id: null,
          doc_number: null,
          doc_date: null,
          doc_type: null,
          doc_surname: null,
          doc_count: null,
          doc_count_2: null,
          doc_number_2: null,
          doc_number_and_date: null,
          doc_callback: null,
          doc_comment: null,
          date_disable: false,
        }),
        filter: {
          dateStart: null,
          dateEnd: null,
        },
        editmode: false,
        colors: ["#FAF7F0", "#D8D2C2"],
      }
    },
    methods: {
      randomColor(id) {
        if((id % 2) == 0){
          return this.colors[0]
        }else{
          return this.colors[1]
        }
      },
      SuccessToast(){
        Toast.fire({
          icon: 'success',
          title: 'Успешно'
        });
      },
      ErrorToast(){
        Toast.fire({
          icon: 'error',
          title: 'Ошибка'
        });
      },
      editRecord(record, organization, answers_count){
        this.editmode = true;
        this.recordform.reset();
        this.recordform.id = record.id;
        this.recordform.organization_id = organization.id;
        this.recordform.doc_number = record.doc_number;
        this.recordform.doc_date = record.doc_date;
        this.recordform.doc_type = record.doc_type;
        this.recordform.doc_surname = record.doc_surname;
        this.recordform.doc_count = record.doc_count;
        this.recordform.doc_count_2 = record.doc_count_2;
        this.recordform.doc_number_2 = record.doc_number_2;
        this.recordform.doc_number_and_date = record.doc_number_and_date;
        this.recordform.doc_callback = record.doc_callback;
        this.recordform.doc_comment = record.doc_comment;
        if(answers_count > 1)
          this.recordform.date_disable = true;
        $('#addNewRecord').modal('show');
      },
      newRecord(){
        this.editmode = false;
        this.recordform.reset();


        $('#addNewRecord').modal('show');
      },
      nextPage(){
        if(this.currentPage < this.lastPage){
          this.currentPage++;
          this.loadRecords();
        }
      },
      selectPage(number){
        this.currentPage = number;
        this.loadRecords();
      },
      prevPage(){
        if(this.currentPage > 1){
          this.currentPage--;
          this.loadRecords();
        }
      },
      search(){
        if(this.timeout)
          clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.$Progress.start();
          this.currentPage = 1;
          this.loadRecords();
          this.$Progress.finish();
        }, 500);

      },
      changePerPage(){
        this.currentPage = 1;
        this.loadRecords();
      },
      createRecord(){
        this.$Progress.start();
        this.recordform.post('/api/journals/77')
        .then((response)=>{
          $('#addNewRecord').modal('hide');
          this.SuccessToast();
          this.loadRecords();
          this.recordform.reset();
          this.$Progress.finish();
        })
        .catch(()=>{
          this.ErrorToast();
          this.$Progress.fail();
        })
      },
      updateRecord(){
        this.$Progress.start();
        this.recordform.put('/api/journals/'+ this.recordform.id)
            .then((response) => {
              $('#addNewRecord').modal('hide');
              this.SuccessToast();
              this.loadRecords();
              this.recordform.reset();
              this.$Progress.finish();
            })
            .catch(() => {
              this.ErrorToast();
              this.$Progress.fail();
            });
      },
      deleteRecord(id){
        Swal.fire({
          title: 'Вы уверены?',
          text: "Это действие нельзя будет отменить",
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          cancelButtonText: 'Отмена',
          confirmButtonText: 'Да, удалить'
        }).then((result) => {
          if (result.value) {
            this.recordform.delete('/api/journals/' + id).then(()=>{
              this.SuccessToast();
              this.loadRecords();
            }).catch((data)=> {
              this.ErrorToast();
            });
          }
        })
      },
      loadRecords(){
        axios.get('/api/journals/77?page='+this.currentPage+'&search='+this.searchQuery+'&perPage='+this.perPage).then(({ data }) => {
          this.records = data.data;
          this.lastPage = data.last_page;
          console.log(data.data)
        });
      },
      loadOrganizations(){
        axios.get('/api/organization').then(({ data }) => {
          this.organizations = data;
        });
      },
      closeModal(){
        this.recordform.reset();
        $('#addNewRecord').modal('hide');
        $('#filterExport').modal('hide');
      },
      filterExport(){
        this.filter.dateStart = null;
        this.filter.dateEnd = null;

        $('#filterExport').modal('show');
      }
    },
    created() {
      this.$Progress.start();
      this.loadRecords();
      this.loadOrganizations();
      this.$Progress.finish();
    }
  }
</script>
